import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { FileText } from 'lucide-react';

// Refactored Components
import { AnalyticsDashboard } from '../components/reports/AnalyticsDashboard';
import { ReportGeneratorHub } from '../components/reports/ReportGeneratorHub';

export const AdvancedReports: React.FC = () => {
    // Determine initial tab based on URL path
    const location = useLocation?.() || { pathname: '' };
    const [activeTab, setActiveTab] = useState<'analytics' | 'generator'>(() => {
        return location.pathname.includes('generator') ? 'generator' : 'analytics';
    });

    // Update tab if location changes
    useEffect(() => {
        if (location.pathname.includes('generator')) {
            setActiveTab('generator');
        } else if (location.pathname.includes('advanced')) {
            setActiveTab('analytics');
        }
    }, [location.pathname]);

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 to-purple-50 dark:from-slate-900 dark:to-slate-800 p-6">
            {/* Header */}
            <div className="mb-6">
                <div className="flex items-center justify-between mb-4">
                    <div>
                        <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">
                            {activeTab === 'analytics' ? '📊 Advanced Reports & Analytics' : '📑 Report Generation Hub'}
                        </h1>
                        <p className="text-gray-600 dark:text-gray-400">
                            {activeTab === 'analytics'
                                ? 'Phase 3 Charts: Waterfall, Control Charts, Box & Whisker, Monte Carlo, and Sankey'
                                : 'Create, Approve, and Publish Technical Reports from Lab & Field Data'
                            }
                        </p>
                    </div>

                    <div className="flex items-center bg-white dark:bg-slate-800 p-1 rounded-lg border border-gray-200 dark:border-slate-700 shadow-sm">
                        <button
                            onClick={() => setActiveTab('analytics')}
                            className={`px-4 py-2 rounded-md font-medium transition-all ${activeTab === 'analytics'
                                ? 'bg-blue-600 text-white shadow-sm'
                                : 'text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-slate-700'
                                }`}
                        >
                            Analytics
                        </button>
                        <button
                            onClick={() => setActiveTab('generator')}
                            className={`px-4 py-2 rounded-md font-medium transition-all flex items-center gap-2 ${activeTab === 'generator'
                                ? 'bg-blue-600 text-white shadow-sm'
                                : 'text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-slate-700'
                                }`}
                        >
                            <FileText className="w-4 h-4" /> Report Generator
                        </button>
                    </div>
                </div>
            </div>

            {/* Content Area */}
            {activeTab === 'analytics' ? <AnalyticsDashboard /> : <ReportGeneratorHub />}
        </div>
    );
};

export default AdvancedReports;
